import { gql, useApolloClient, useLazyQuery, useQuery, } from '@apollo/client';
import { OCCUPANT_FIELDS } from 'common-app/api/fragments/bailleurs-participant';
export const OCCUPANT_READ = gql `
    ${OCCUPANT_FIELDS}
    query readOccupant($dossierId: Long) {
      read_occupant(dossierId: $dossierId) {
        ...OccupantFields
      }
    }
  `;
export const useOccupantReadLazyQuery = (options) => {
    return useLazyQuery(OCCUPANT_READ, Object.assign({ errorPolicy: 'all' }, options));
};
export const useOccupantReadQuery = (options) => {
    return useQuery(OCCUPANT_READ, Object.assign({ errorPolicy: 'all' }, options));
};
export const useOccupantReadQueryPromise = () => {
    const client = useApolloClient();
    return (variables, options) => client.query(Object.assign(Object.assign({ errorPolicy: 'all' }, options), { query: OCCUPANT_READ, variables }));
};
